import { Paper, Button } from '@mui/material';
import School from '@mui/icons-material/School';
import useTranslation from 'Hooks/useTranslation';
import ui from './index.module.css';

export default function index({ title = '', numberQuestions = 0, onClick = () => {}, duration, alreadyAnswered = null, loadingCheck = false }) {
  const { t2 } = useTranslation('course_test');
  const canRetry = loadingCheck ? false : (alreadyAnswered?.canRetry ?? true);
  const disabled = !canRetry;
  return (
    <Paper className={ui.paperContainer}>
      <div className={ui.paperIcon}>
        <School className={ui.paperIconSize} />
      </div>
      <h1 className={ui.paperTitle}>{title}</h1>
      <section className={ui.PaperMessageContainer}>
        <p className={ui.PaperMessageText}>{t2('testContains', [numberQuestions.toString()])}</p>
        <p className={ui.PaperMessageText}>{t2('readEachQuestion')}</p>
        <p className={ui.PaperMessageText}>{t2('youCanCheckAnswers')}</p>
        <p className={ui.PaperAlert}>{t2('ifLeaveTabTestEnd')}</p>
        <p className={ui.PaperMessageText}>
          {!duration ? t2('evaluationHasNoTime') : t2('evaluationHasTime', [duration])}
        </p>
        {alreadyAnswered?.attemptsCount > 0 && (
          <p className={ui.PaperMessageText}>
            Intento {alreadyAnswered.attemptsCount} de {alreadyAnswered.maxAttempts}
          </p>
        )}
      </section>
      <Button
        disabled={disabled}
        className={disabled ? ui.PaperButtonDisabled : ui.PaperButton}
        onClick={onClick}
      >
        {loadingCheck ? 'Cargando...' : t2('start')}
      </Button>
    </Paper>
  );
}
